import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PlanInfoFeaturesList from './PlanInfoFeaturesList';

interface FreeInfoProps {}

const FreeInfo = ({}: FreeInfoProps) => {
    const { t } = useTranslation();
    return (
        <>
            <div className="InfoPage-features">
                <a
                    href="https://support.fieldmargin.com/en/articles/6478752-what-is-the-30-day-history-limit"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/history.png"
                        alt="Screenshot of activity list in the fieldmargin web app"
                    />
                    <h2>{t('free_history_length')}</h2>
                    <p>
                        {t('free_history_desc', {
                            defaultValue: 'Record all of your Field Jobs and notes over time',
                        })}
                    </p>
                </a>
                <a
                    href="http://support.fieldmargin.com/en/articles/3448658-input-limits"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/inputs.png"
                        alt="Screenshot of field input reporting on the fieldmargin mobile app"
                    />
                    <h2>{t('plan_info_title_five_inputs')}</h2>
                    <p>{t('plan_info_body_five_inputs')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/4480123-how-to-manage-livestock-and-grazing"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/livestock.png"
                        alt="Photo of cows in a shed"
                    />
                    <h2>{t('plan_info_title_one_livestock_herds')}</h2>
                    <p>{t('plan_info_body_two_livestock_herds')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/1869622-upload-your-paper-farm-maps-to-fieldmargin"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/map-uploader.png"
                        alt="Aerial photo of a field"
                    />
                    <h2>
                        {t('plan_info_title_free_map_upload', { defaultValue: '1 Map upload' })}
                    </h2>
                    <p>{t('plan_info_body_map_uploader')}</p>
                </a>
            </div>
            <PlanInfoFeaturesList />
        </>
    );
};

export default FreeInfo;
